export var COMMISSIONS_FETCH_START_ACTION_TYPE = 'commissions/fetch_start';
export var COMMISSIONS_FETCH_SUCCESS_ACTION_TYPE = 'commissions/fetch_success';
export var COMMISSIONS_FETCH_BY_STAFF_MEMBER_START_ACTION_TYPE = 'commissions/fetch_by_staff_member_start';
export var COMMISSIONS_FETCH_BY_STAFF_MEMBER_SUCCESS_ACTION_TYPE = 'commissions/fetch_by_staff_member_success';
export var COMMISSIONS_GET_START_ACTION_TYPE = 'commissions/get_start';
export var COMMISSIONS_GET_SUCCESS_ACTION_TYPE = 'commissions/get_success';
export var COMMISSIONS_SAVE_START_ACTION_TYPE = 'commissions/save_start';
export var COMMISSIONS_SAVE_SUCCESS_ACTION_TYPE = 'commissions/save_success';
export var COMMISSIONS_GET_REPORT_START_ACTION_TYPE = 'commissions/get_report_start';
export var COMMISSIONS_GET_REPORT_SUCCESS_ACTION_TYPE = 'commissions/get_report_success';
export var COMMISSIONS_RESET_ACTION_TYPE = 'commissions/reset';
export var COMMISSIONS_ERROR_ACTION_TYPE = 'commissions/fail';
